/** @jsx jsx */
import { jsx, Separator, Stack } from '@front10/base-elements';
import React, { Fragment } from 'react';

interface Props {
  showSeparator?: boolean;
}

function Panel(props: React.PropsWithChildren<{}>) {
  return (
    <div
      sx={{
        pl: 'dialogMargin',
        pr: 'dialogMargin',
        '& label': {
          fontWeight: 'normal'
        }
      }}
    >
      {props.children}
    </div>
  );
}

export function Panels(props: React.PropsWithChildren<Props>) {
  const { showSeparator = true } = props;
  const children = React.Children.toArray(props.children).filter((child) => child !== null);
  const lastIndex = children.length - 1;

  const result = children.map((element, index) => {
    let wrapper = <Panel key={index.toString()}>{element}</Panel>;
    if (index === lastIndex) {
      return wrapper;
    }
    return (
      <Fragment key={index.toString()}>
        {wrapper}
        {showSeparator && <Separator />}
      </Fragment>
    );
  });

  return (
    (
      <Stack gap="dialogMargin" pt="dialogMargin" pb="dialogMargin">
        {result}
      </Stack>
    ) ?? null
  );
}
